import { render, staticRenderFns } from "./QuickVerifyIcon.vue?vue&type=template&id=1501add2&scoped=true&"
import script from "./QuickVerifyIcon.vue?vue&type=script&lang=js&"
export * from "./QuickVerifyIcon.vue?vue&type=script&lang=js&"
import style0 from "./QuickVerifyIcon.vue?vue&type=style&index=0&id=1501add2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1501add2",
  null
  
)

export default component.exports